<div class="gl-skeleton">
  <div class="gl-skeleton__nav">
    <div class="gl-skeleton__list navMenu">
      <div class="gl-skeleton__list--item">
        <div class="gl-skeleton__circle small animation"></div>
        <div class="gl-skeleton__line small thin animation gap"></div>
      </div>
      <div class="gl-skeleton__list--item">
        <div class="gl-skeleton__circle small animation"></div>
        <div class="gl-skeleton__line medium thin animation gap"></div>
      </div>
      <div class="gl-skeleton__list--item">
        <div class="gl-skeleton__circle small animation"></div>
        <div class="gl-skeleton__line large thin animation gap"></div>
      </div>
      <div class="gl-skeleton__list--item">
        <div class="gl-skeleton__circle small animation"></div>
        <div class="gl-skeleton__line large thin animation gap"></div>
      </div>
      <div class="gl-skeleton__list--item">
        <div class="gl-skeleton__circle small animation"></div>
        <div class="gl-skeleton__line large thin animation gap"></div>
      </div>
      <div class="gl-skeleton__list--item">
        <div class="gl-skeleton__circle small animation"></div>
        <div class="gl-skeleton__line medium thin animation gap"></div>
      </div>
      <div class="gl-skeleton__list--item">
        <div class="gl-skeleton__circle small animation"></div>
        <div class="gl-skeleton__line small thin animation gap"></div>
      </div>
      <div class="gl-skeleton__list--item">
        <div class="gl-skeleton__circle small animation"></div>
        <div class="gl-skeleton__line large thin animation gap"></div>
      </div>
      <div class="gl-skeleton__list--item">
        <div class="gl-skeleton__circle small animation"></div>
        <div class="gl-skeleton__line small thin animation gap"></div>
      </div>
      <div class="gl-skeleton__list--item">
        <div class="gl-skeleton__circle small animation"></div>
        <div class="gl-skeleton__line medium thin animation gap"></div>
      </div>
      <div class="gl-skeleton__list--item">
        <div class="gl-skeleton__circle small animation"></div>
        <div class="gl-skeleton__line large thin animation gap"></div>
      </div>
      <div class="gl-skeleton__list--item">
        <div class="gl-skeleton__circle small animation"></div>
        <div class="gl-skeleton__line large thin animation gap"></div>
      </div>
      <div class="gl-skeleton__list--item">
        <div class="gl-skeleton__circle small animation"></div>
        <div class="gl-skeleton__line large thin animation gap"></div>
      </div>
      <div class="gl-skeleton__list--item">
        <div class="gl-skeleton__circle small animation"></div>
        <div class="gl-skeleton__line medium thin animation gap"></div>
      </div>
    </div>
  </div>
  <div class="gl-skeleton__topBar">
    <div class="gl-skeleton__header">
      <div class="gl-skeleton__list flex-end">
        <div class="gl-skeleton__line animation"></div>
        <div class="gl-skeleton__line medium animation gap"></div>
        <div class="gl-skeleton__line small animation gap"></div>
        <div class="gl-skeleton__line small animation gap"></div>
        <div class="gl-skeleton__circle medium animation gap"></div>
        <div class="gl-skeleton__circle animation gap"></div>
      </div>
    </div>
    <div class="gl-skeleton__breadcrumb">
      <div class="gl-skeleton__list">
        <div class="gl-skeleton__circle animation"></div>
        <div class="gl-skeleton__line small animation gap"></div>
        <div class="gl-skeleton__line small thin animation gap"></div>
      </div>
    </div>
    <div class="gl-skeleton__body">
      <div class="gl-skeleton__line small animation"></div>
      <div class="gl-skeleton__line medium animation"></div>
      <div class="gl-skeleton__line large animation"></div>
      <div class="gl-skeleton__line animation"></div>
    </div>
  </div>
</div>
